import React from 'react';
import { Form, Modal } from 'antd';
import SuggestedStationForm from '../../forms/SuggestedStationForm';
import { addSuggestedStations } from '../../../../services/admin/stationServices';
import formSetDynamicErrors from '../../../../utils/functions/formSetDynamicErrors';
import useTranslation from '../../../hooks/translation/useTranslation';

function AddSuggestedStationModal({ show, setShow, refetchData }) {
  const { trans } = useTranslation();
  const [form] = Form.useForm();

  const handleFinish = async (values) => {
    try {
      await addSuggestedStations(values);
      setShow(false);
      refetchData();
    } catch (e) {
      if (e?.response?.data?.errors) {
        formSetDynamicErrors({ e, form });
      }
    }
  };
  return (
    <Modal
      open={show}
      footer={null}
      show={show}
      setShow={setShow}
      onCancel={() => setShow(false)}
    >
      <h3 className="text-center">
        {trans('input_station_data')}
      </h3>
      <SuggestedStationForm form={form} onFinish={handleFinish} />
    </Modal>
  );
}

export default AddSuggestedStationModal;
